module.exports = __webpack_public_path__ + "static/home2-39f228ae01ede252581a48ef4ee35930.jpeg";